// Dev (CRA dev server su :3000): il backend si raggiunge via docker nginx su localhost.
// Test/Prod: nginx serve la pagina e proxya /ws/ -> stessa origin.

const isDevServer = window.location.port === "3000";

const SERVER_IP_STRING = isDevServer
  ? "ws://localhost/ws/"
  : `${window.location.protocol === "https:" ? "wss" : "ws"}://${window.location.host}/ws/`;

const ws = new WebSocket(SERVER_IP_STRING);

export default ws;
